var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectionMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_503047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0007 0C10.1192 0 5.33398 4.78519 5.33398 10.6667C5.33398 12.4329 5.77542 14.1836 6.61392 15.7364L15.4173 31.6562C15.5345 31.8685 15.7585 32 16.0007 32C16.2429 32 16.4668 31.8685 16.584 31.6556L25.3887 15.7305C26.2259 14.1849 26.6673 12.4336 26.6673 10.6667C26.6674 4.78519 21.8822 0 16.0007 0ZM24.2194 15.0911L16.0007 29.9557L7.78323 15.0964C7.05405 13.7442 6.66736 12.2123 6.66736 10.6667C6.66736 5.52019 10.8549 1.33337 16.0007 1.33337C21.1465 1.33337 25.334 5.52025 25.334 10.6667C25.334 12.2129 24.9473 13.7448 24.2194 15.0911Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0013 3.3335C11.9583 3.3335 8.66797 6.62318 8.66797 10.6668C8.66797 14.7104 11.9583 18.0002 16.0013 18.0002C20.0442 18.0002 23.3346 14.7105 23.3346 10.6669C23.3346 6.62325 20.0443 3.3335 16.0013 3.3335ZM16.0013 16.6669C12.6927 16.6669 10.0013 13.9754 10.0013 10.6669C10.0013 7.35831 12.6927 4.66687 16.0013 4.66687C19.3098 4.66687 22.0013 7.35831 22.0013 10.6669C22.0013 13.9754 19.3099 16.6669 16.0013 16.6669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.862 8.1953L14.6666 12.3906L13.138 10.862C12.8776 10.6016 12.4557 10.6016 12.1953 10.862C11.9349 11.1224 11.9349 11.5443 12.1953 11.8047L14.1953 13.8047C14.3255 13.9349 14.4961 14 14.6667 14C14.8373 14 15.0078 13.9349 15.1381 13.8047L19.8048 9.13799C20.0652 8.87755 20.0652 8.45568 19.8048 8.1953C19.5443 7.93493 19.1223 7.93487 18.862 8.1953Z",
    fill: "black"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionMap);
export default __webpack_public_path__ + "static/media/collection-map.60bd96b8af853085393701fc3e7abbdf.svg";
export { ForwardRef as ReactComponent };